module.exports = __webpack_public_path__ + "img/trashcan.4bbe782c.svg";